import { getUniqueId } from '@/editor/utils';
import { ENTITY_RENDER_ORDER } from '@/editor/constant/entity';
import { EEntityType } from '@/editor/types';
import { Mesh, MeshBasicMaterial, RepeatWrapping, ShapeGeometry, TextureLoader } from 'three';
import { IMaterialInfo } from '@/editor/data/material/material';
import { createMaterial } from '@/editor/data/material/utils';
import { IShapePoint2d } from '@/editor/types/shape';
import { pathToGmtShape } from '@/editor/utils/shape';

class FloorPlane {
  private _id: string;
  private _path: IShapePoint2d[];
  private _floorMesh: Mesh;
  private _type: EEntityType;
  private _material: MeshBasicMaterial;
  private _holes: IShapePoint2d[][];
  private _materialInfo: IMaterialInfo;

  constructor(path: IShapePoint2d[], holes: IShapePoint2d[][], type: EEntityType, materialInfo: IMaterialInfo) {
    this._path = path;
    this._holes = holes;
    this._type = type;
    this._id = getUniqueId(); // 生成一个唯一的ID
    this._materialInfo = materialInfo;

    const geometry = this.createFloorEntGeometry();
    this._material = this.getMaterial();
    this._floorMesh = new Mesh(geometry, this._material);
    this._floorMesh.renderOrder =
      this._type === EEntityType.Region ? ENTITY_RENDER_ORDER.region : ENTITY_RENDER_ORDER.floor;
    this._floorMesh.userData.type = type;
    this._floorMesh.userData.priority = 1;
    this._floorMesh.material = this._material;
  }

  private getMaterial() {
    const material = createMaterial(this._materialInfo.id, true) as MeshBasicMaterial;

    return material;
  }

  private createTextureMaterial(texturePath: string) {
    // 创建纹理加载器
    const textureLoader = new TextureLoader();
    // 加载贴图
    const texture = textureLoader.load(texturePath);
    texture.wrapS = RepeatWrapping;
    texture.wrapT = RepeatWrapping;
    // 获取UV坐标
    // const uvAttribute = geometry.attributes.uv;
    // 修改UV坐标以实现平铺
    // for (let i = 0; i < uvAttribute.count; i++) {
    //   uvAttribute.setX(i, uvAttribute.getX(i) * 10);
    //   uvAttribute.setY(i, uvAttribute.getY(i) * 10);
    // }
    // 创建材质和网格
    const material = new MeshBasicMaterial({
      map: texture
    });

    return material;
  }

  private createFloorEntGeometry() {
    const shape = pathToGmtShape(this._path, this._holes);
    const geometry = new ShapeGeometry(shape);
    return geometry;
  }

  updateFloorPlane(path: IShapePoint2d[], holes: IShapePoint2d[][]) {
    this._path = path;
    this._holes = holes;
    const geometry = this.createFloorEntGeometry();
    if (geometry) {
      this._floorMesh.geometry.dispose();
      this._floorMesh.geometry = geometry;
    }
  }

  get path() {
    return this._path;
  }

  get id() {
    return this._id;
  }

  get floorMesh() {
    return this._floorMesh;
  }

  modifyFloorMaterial(modifyMaterialInfo: IMaterialInfo) {
    if (modifyMaterialInfo.id === this._materialInfo.id) return;

    this._materialInfo = { ...modifyMaterialInfo };
    const newMaterialInfo = this.getMaterial();
    (this._floorMesh.material as MeshBasicMaterial).dispose();
    this._floorMesh.material = newMaterialInfo;
    this.updateFloorPlane(this._path, this._holes);
  }
}

export default FloorPlane;
